// Mock Block Data - İNŞA ET
// Blok yapısı ve daire atamaları

export const mockBlocks = [
    // Yeşil Park Konutları - 2 Blok
    {
        id: 'b1',
        constructionId: 'c1',
        constructionName: 'Yeşil Park Konutları',
        name: 'A Blok',
        totalFloors: 4,
        apartmentsPerFloor: 2,
        totalApartments: 8,
        soldApartments: 5,
        reservedApartments: 1,
        emptyApartments: 2,
        status: 'active',
        createdAt: '2025-01-15T10:00:00Z',
        updatedAt: '2025-12-28T15:30:00Z',
    },
    {
        id: 'b2',
        constructionId: 'c1',
        constructionName: 'Yeşil Park Konutları',
        name: 'B Blok',
        totalFloors: 4,
        apartmentsPerFloor: 2,
        totalApartments: 8,
        soldApartments: 3,
        reservedApartments: 2,
        emptyApartments: 3,
        status: 'active',
        createdAt: '2025-01-15T10:00:00Z',
        updatedAt: '2025-12-28T15:30:00Z',
    },

    // Global Rezidans - 3 Blok
    {
        id: 'b3',
        constructionId: 'c2',
        constructionName: 'Global Rezidans',
        name: 'A Blok',
        totalFloors: 6,
        apartmentsPerFloor: 2,
        totalApartments: 12,
        soldApartments: 7,
        reservedApartments: 3,
        emptyApartments: 2,
        status: 'active',
        createdAt: '2025-06-01T10:00:00Z',
        updatedAt: '2025-12-30T11:45:00Z',
    },
    {
        id: 'b4',
        constructionId: 'c2',
        constructionName: 'Global Rezidans',
        name: 'B Blok',
        totalFloors: 6,
        apartmentsPerFloor: 2,
        totalApartments: 12,
        soldApartments: 6,
        reservedApartments: 3,
        emptyApartments: 3,
        status: 'active',
        createdAt: '2025-06-01T10:00:00Z',
        updatedAt: '2025-12-30T11:45:00Z',
    },
    {
        id: 'b5',
        constructionId: 'c2',
        constructionName: 'Global Rezidans',
        name: 'C Blok',
        totalFloors: 6,
        apartmentsPerFloor: 2,
        totalApartments: 12,
        soldApartments: 5,
        reservedApartments: 2,
        emptyApartments: 5,
        status: 'active',
        createdAt: '2025-06-01T10:00:00Z',
        updatedAt: '2025-12-30T11:45:00Z',
    },
];

// Helper function to get blocks by construction ID
export const getBlocksByConstructionId = (constructionId) => {
    return mockBlocks.filter(block => block.constructionId === constructionId);
};

export default mockBlocks;
